import React, { ReactElement } from 'react';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { SubheaderText } from 'components/general';
import {
  inspectionFormSectionDescriptionSx,
  inspectionSectionPaddingSx,
  inspectionSubheaderBaseSx,
} from 'components/inspection/layout';
import { FormSectionProps } from './types';
import {
  FORM_SECTION_CARD_SX,
  FORM_SECTION_TITLE_SX,
  FORM_SECTION_DESCRIPTION_SX,
} from './styles';

function FormSection({
  title,
  titleId,
  description,
  descriptionId,
  children,
  required,
  variant = 'card',
}: FormSectionProps): ReactElement {
  const intl = useIntl();

  const displayTitle = titleId
    ? formatTranslation(intl, unsafeTranslationKey(titleId))
    : title;
  const displayDescription = descriptionId
    ? formatTranslation(intl, unsafeTranslationKey(descriptionId))
    : description;

  if (variant === 'page') {
    return (
      <Box>
        {displayTitle ? (
          <SubheaderText
            sx={{
              ...inspectionSubheaderBaseSx,
              mt: 4,
              mb: displayDescription ? 1 : 2,
            }}
          >
            {displayTitle}
            {required && ' *'}
          </SubheaderText>
        ) : null}
        {displayDescription ? (
          <Typography component="p" sx={inspectionFormSectionDescriptionSx}>
            {displayDescription}
          </Typography>
        ) : null}
        <Box sx={inspectionSectionPaddingSx}>{children}</Box>
      </Box>
    );
  }

  return (
    <Box sx={FORM_SECTION_CARD_SX}>
      {displayTitle && (
        <Typography component="h3" sx={FORM_SECTION_TITLE_SX}>
          {displayTitle}
          {required && ' *'}
        </Typography>
      )}
      {displayDescription && (
        <Typography component="p" sx={FORM_SECTION_DESCRIPTION_SX}>
          {displayDescription}
        </Typography>
      )}
      {children}
    </Box>
  );
}

export const MemoFormSection = React.memo(FormSection);
